import * as React from 'react';
import dynamic from 'next/dynamic';
import { IconProps } from '@mybet/components/Icons';
const TrustlyIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "TrustlyIcon"*/ '@mybet/components/Icons/Trustly'
    )
);
const TrustlyLargeIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "TrustlyLargeIcon"*/ '@mybet/components/Icons/TrustlyLarge'
    )
);
const SofortIcon = dynamic(
  () =>
    import(/* webpackChunkName: "SofortIcon"*/ '@mybet/components/Icons/Sofort')
);
const SofortLargeIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "SofortLargeIcon"*/ '@mybet/components/Icons/SofortLarge'
    )
);
const PaysafeIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "PaysafeIcon"*/ '@mybet/components/Icons/Paysafe'
    )
);
const PaysafeLargeIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "PaysafeLargeIcon"*/ '@mybet/components/Icons/PaysafeLarge'
    )
);
const PayPalIcon = dynamic(
  () =>
    import(/* webpackChunkName: "PayPalIcon"*/ '@mybet/components/Icons/PayPal')
);
const PayPalLargeIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "PayPalLargeIcon"*/ '@mybet/components/Icons/PayPalLarge'
    )
);
const VisaIcon = dynamic(
  () => import(/* webpackChunkName: "VisaIcon"*/ '@mybet/components/Icons/Visa')
);

const VisaLargeIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "VisaLargeIcon"*/ '@mybet/components/Icons/VisaLarge'
    )
);
const MasterCardIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "MasterCardIcon"*/ '@mybet/components/Icons/MasterCard'
    )
);
const MasterCardLargeIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "MasterCardLargeIcon"*/ '@mybet/components/Icons/MasterCardLarge'
    )
);
const BankTransferIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "BankTransferIcon"*/ '@mybet/components/Icons/BankTransfer'
    )
);
const CreditCardIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "CreditCardIcon"*/ '@mybet/components/Icons/CreditCard'
    )
);
const Cash2CodeIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "Cash2CodeIcon"*/ '@mybet/components/Icons/Cash2Code'
    )
);
const OnlineUberweisungIcon = dynamic(
  () =>
    import(
      /* webpackChunkName: "OnlineUberweisungIcon"*/ '@mybet/components/Icons/OnlineUberweisung'
    )
);

enum PaymentMethodIcons {
  trustly = 'trustly',
  trustly_large = 'trustly_large',
  sofort = 'sofort',
  sofort_large = 'sofort_large',
  paysafe = 'paysafe',
  paysafe_large = 'paysafe_large',
  paypal = 'paypal',
  paypal_large = 'paypal_large',
  visa = 'visa',
  visa_large = 'visa_large',
  mastercard = 'mastercard',
  mastercard_large = 'mastercard_large',
  banktransfer = 'banktransfer',
  creditcard = 'creditcard',
  cash2code = 'cash2code',
  online_uberweisung = 'online_uberweisung',
}
export type PaymentMethodIcon = keyof typeof PaymentMethodIcons;
type PaymentIconProps = IconProps & {
  icon: PaymentMethodIcon;
};

const PaymentIcon: React.FC<PaymentIconProps> = (props) => {
  const { icon, ...rest } = props;
  return (
    <>
      {icon === 'trustly' && <TrustlyIcon {...rest} />}
      {icon === 'trustly_large' && <TrustlyLargeIcon {...rest} />}
      {icon === 'sofort' && <SofortIcon {...rest} />}
      {icon === 'sofort_large' && <SofortLargeIcon {...rest} />}
      {icon === 'paysafe' && <PaysafeIcon {...rest} />}
      {icon === 'paysafe_large' && <PaysafeLargeIcon {...rest} />}
      {icon === 'paypal' && <PayPalIcon {...rest} />}
      {icon === 'paypal_large' && <PayPalLargeIcon {...rest} />}
      {icon === 'visa' && <VisaIcon {...rest} />}
      {icon === 'visa_large' && <VisaLargeIcon {...rest} />}
      {icon === 'mastercard' && <MasterCardIcon {...rest} />}
      {icon === 'mastercard_large' && <MasterCardLargeIcon {...rest} />}
      {icon === 'banktransfer' && <BankTransferIcon {...rest} />}
      {icon === 'creditcard' && <CreditCardIcon {...rest} />}
      {icon === 'cash2code' && <Cash2CodeIcon {...rest} />}
      {icon === 'online_uberweisung' && <OnlineUberweisungIcon {...rest} />}
    </>
  );
};

export default PaymentIcon;
